import React, { useEffect, useState } from 'react';
import HeaderRec from '../../header/headerRec';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../commun/Pagination';
import GenericTable from '../../commun/GenericTable';
import StatusTabs from '../../commun/StatusTabs';
import { recruteurCandidatureStatus, recruteurCandidatureStatusCandidatureStatus } from '../../commun/constants/options';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import '../../Entreprise/CandidaturesEntreprise/CandidaturesEntreprise.css';

const Candidature = () => {
  const navigate = useNavigate();
  const recruteurName = localStorage.getItem('recruteurName');
  const authToken = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [allCandidatures, setAllCandidatures] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState(null);
  const [grouped, setGrouped] = useState({});
  const [page, setPage] = useState(1);
  const [displayMode, setDisplayMode] = useState('table'); 

  const itemsPerPage = 8;

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) navigate('/');
  }, [navigate]);

  useEffect(() => {
    const fetchCandidatures = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/recruteur/candidatures?userId=${userId}`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        const data = await res.json();
        data.sort((a, b) => new Date(b.dateEnvoi) - new Date(a.dateEnvoi));
        setAllCandidatures(data);
      } catch (err) {
        console.error('Erreur de chargement des candidatures:', err);
      }
    };

    fetchCandidatures();
  }, [authToken]);

  useEffect(() => {
    const group = {};
    allCandidatures.forEach((c) => {
      const stat = c.statut || 'Inconnu';
      if (!group[stat]) group[stat] = [];
      group[stat].push(c);
    });
    setGrouped(group);
  }, [allCandidatures]);

  useEffect(() => {
    setPage(1);
  }, [filteredStatus]);

  const displayedCandidatures = filteredStatus
    ? grouped[filteredStatus] || []
    : allCandidatures;

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;
  const paginatedCandidatures = displayedCandidatures.slice(startIndex, endIndex);

  const columns = [
    { key: 'reference', label: 'Référence candidat' },
    { key: 'reference', label: 'Score' },
    { key: 'talent', label: 'Talent' },
    { key: 'dateEnvoi', label: 'Date de candidature' },
    { key: 'mission', label: 'Mission' },
    { key: 'entreprise', label: 'Entreprise' },
    { key: 'statut', label: 'Statut' },
  ];

  const renderActions = (row) => {
    const statut = typeof row.rawStatut === 'string' ? row.rawStatut.toLowerCase() : '';
    const isDraft = statut === 'brouillon';

    return (
      <button
        className="btn-detail"
        onClick={() => {
          if (isDraft) {
            navigate(`/recruteur/travailler-mission/${row.missionId}?t=${row.candidatId}`);
          } else {
            navigate(`/Recruteur/DetailsCandidature/${row._id}`);
          }
        }}
      >
        {isDraft ? 'Reprendre' : 'Détails'}
      </button>
    );
  };

const tableData = displayedCandidatures.map((c) => {
    const rawStatus = c.statut || 'Inconnu';
    const matchedStatus = recruteurCandidatureStatus.find((s) => s.value.toLowerCase() === rawStatus.toLowerCase());
    console.log("j", c)
    return {
      reference: (
        <Link to={`/Recruteur/talent-detail/${c.candidatId._id}`}>
          {c.candidatId.reference || 'N/A'}
        </Link>
      ),
      talent: c.candidatId?.nomCandidat || 'N/A',
      mission: c.missionId?.nomMission || 'N/A',
      entreprise: c.entreprise,
      dateEnvoi: c.dateEnvoi
        ? new Date(c.dateEnvoi).toLocaleDateString('fr-FR')
        : 'N/A',
      statut: (
        <span className="status-cell" style={matchedStatus?.style}>
          {rawStatus === 'A traiter'
            ? 'Candidature envoyée'
            : matchedStatus?.label || rawStatus}
        </span>
      ),
      _id: c._id,
      rawStatut: rawStatus,
      candidatId: c.candidatId?._id,
      missionId: c.missionId?._id,
    };
  });

  return (
    <div className="recruteur-page">
      <HeaderRec
        recruteurName={recruteurName}
        authToken={authToken}
        userId={userId}
      />
      <main className="pageContainer">
        <h2 className="pageTitle">Mes candidatures</h2>

        <StatusTabs
          statuses={grouped}
          activeStatus={filteredStatus}
          onStatusChange={setFilteredStatus}
          statusStylesSource={recruteurCandidatureStatus}
          userRole="recruteur"
        />

        <div className="tableWrapper">
       <GenericTable
  columns={columns}
  data={tableData}
  renderActions={renderActions}
  totalItems={displayedCandidatures.length}
  showCheckboxes={false}
  itemsPerPage={itemsPerPage}
  currentPage={page}
  setPage={setPage}
  displayMode={displayMode}
  setDisplayMode={setDisplayMode}
/>


          {displayMode === 'table' && displayedCandidatures.length > 0 && (
  <Pagination
    page={page}
    setPage={setPage}
    totalItems={displayedCandidatures.length}
    itemsPerPage={itemsPerPage}
  />
)}


          <Chatbox userRole="recruteur" />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Candidature;
